function Loader(){
    return <h3 style={{color:"lightgreen"}}>...Loading</h3>
}

export default Loader;